"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TaxiFoglalasHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="taxi-foglalás-hero" className="relative flex min-h-[80vh] items-center justify-center overflow-hidden py-[120px]">
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/premium_black_car_coastal_airport.png)] bg-cover bg-center bg-no-repeat" />

      <div className="absolute inset-0 bg-gradient-to-br from-primary/40 to-teal-400/40" />

      <div ref={ref} className={`relative z-10 container mx-auto flex flex-col items-center px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <h1 className="mb-6 max-w-4xl font-serif text-5xl font-bold leading-tight text-secondary md:text-[4.5rem]">
          Prémium Taxi és Transzfer
        </h1>
      </div>
    </section>;
}